(function () {
  // Mobile menu
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      if (!nav) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      nav.setAttribute('data-open', String(!open));
    });
  });

  // Product: offer cards, gallery, sticky bar
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var dataEl = root.querySelector('[data-product-json]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = root.querySelector('[name="id"]');
    var priceEls = document.querySelectorAll('[data-product-price]');
    var submit = root.querySelector('[data-add-to-cart]');
    var mainImg = document.getElementById('ProductMainImage');

    function select(id) {
      var v = variants.find(function (x) { return String(x.id) === String(id); });
      if (!v) return;
      idInput.value = v.id;
      priceEls.forEach(function (el) { el.textContent = v.price_formatted; });
      document.querySelectorAll('[data-product-compare]').forEach(function (el) { el.textContent = v.compare_formatted || ''; });
      document.querySelectorAll('[data-offer-qty]').forEach(function (el) { el.textContent = v.title; });
      if (submit) {
        submit.disabled = !v.available;
        submit.querySelector('[data-label]').textContent = v.available ? submit.getAttribute('data-label-available') : submit.getAttribute('data-label-soldout');
      }
      if (v.featured_image && mainImg) {
        mainImg.src = v.featured_image;
        mainImg.removeAttribute('srcset');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.querySelectorAll('[name="offer"]').forEach(function (radio) {
      radio.addEventListener('change', function () { select(radio.value); });
    });

    // AliExpress peut fournir quantité et couleur dans un seul libellé (ex. 6pcsBrown).
    // Lorsque toute la grille est reconnue, on présente deux choix clairs au client.
    var picker = root.querySelector('[data-variant-picker]');
    var legacyOffers = root.querySelector('[data-legacy-offers]');
    function parsePack(title) {
      var text = String(title || '').trim();
      var match = text.match(/(\d+)\s*(?:pcs?|pi[eè]ces?)/i);
      if (!match) return null;
      var color = text.replace(match[0], '').replace(/[—–_-]+/g, ' ').trim();
      var colors = { black: 'Noir', pink: 'Rose', khaki: 'Kaki', brown: 'Marron', white: 'Blanc', blue: 'Bleu', red: 'Rouge', green: 'Vert' };
      color = colors[color.toLowerCase()] || color;
      return color ? { quantity: match[1] + ' pièces', color: color } : null;
    }
    var parsed = variants.map(function (variant) {
      var values = parsePack(variant.title);
      return values ? { variant: variant, quantity: values.quantity, color: values.color } : null;
    });
    if (picker && parsed.length > 1 && parsed.every(Boolean)) {
      var quantities = Array.from(new Set(parsed.map(function (x) { return x.quantity; })));
      var colors = Array.from(new Set(parsed.map(function (x) { return x.color; })));
      if (quantities.length > 1 && colors.length > 1) {
        function group(label, values, name) {
          var wrap = document.createElement('div');
          wrap.className = 'product-option-group';
          var title = document.createElement('label');
          title.textContent = label;
          var rail = document.createElement('div');
          rail.className = 'product-option-rail';
          rail.setAttribute('data-pack-option', name);
          var field = { value: values[0], set: function (value) {
            field.value = value;
            rail.querySelectorAll('button').forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.value === value)); });
          } };
          values.forEach(function (value) {
            var button = document.createElement('button');
            button.type = 'button'; button.className = 'product-option-card'; button.dataset.value = value; button.textContent = value; button.setAttribute('aria-pressed', 'false');
            button.addEventListener('click', function () { field.set(value); choosePack(); });
            rail.appendChild(button);
          });
          wrap.appendChild(title); wrap.appendChild(rail); picker.appendChild(wrap);
          return field;
        }
        var quantityField = group('Quantité', quantities, 'quantity');
        var colorField = group('Couleur', colors, 'color');
        var checked = root.querySelector('[name="offer"]:checked');
        var current = parsed.find(function (x) { return checked && String(x.variant.id) === String(checked.value); }) || parsed[0];
        quantityField.set(current.quantity); colorField.set(current.color);
        function choosePack() {
          var choice = parsed.find(function (x) { return x.quantity === quantityField.value && x.color === colorField.value; });
          if (!choice) return;
          var radio = root.querySelector('[name="offer"][value="' + choice.variant.id + '"]');
          if (radio) radio.checked = true;
          select(choice.variant.id);
        }
        picker.hidden = false;
        if (legacyOffers) legacyOffers.hidden = true;
      }
    }

    var slider = root.querySelector('[data-slider]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    function markThumb(i) {
      thumbs.forEach(function (t) { t.setAttribute('aria-current', String(t.getAttribute('data-index') === String(i))); });
      var cur = root.querySelector('[data-thumb][data-index="' + i + '"]');
      var strip = cur && cur.parentElement;
      if (strip) strip.scrollTo({ left: cur.offsetLeft - (strip.clientWidth - cur.clientWidth) / 2, behavior: 'smooth' });
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!slider) return;
        var i = Number(thumb.getAttribute('data-index'));
        slider.scrollTo({ left: i * slider.clientWidth, behavior: 'smooth' });
        markThumb(i);
      });
    });
    if (slider) {
      var t0;
      slider.addEventListener('scroll', function () {
        clearTimeout(t0);
        t0 = setTimeout(function () { markThumb(Math.round(slider.scrollLeft / slider.clientWidth)); }, 80);
      }, { passive: true });
    }

    var stickyAdd = document.querySelector('[data-sticky-add]');
    var form = document.getElementById('ProductForm');
    if (stickyAdd && form && submit) {
      stickyAdd.addEventListener('click', function (e) {
        e.preventDefault();
        if (submit.disabled) return;
        if (form.requestSubmit) form.requestSubmit(submit); else submit.click();
      });
    }

    var sticky = document.querySelector('[data-sticky-atc]');
    if (sticky && submit && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.setAttribute('data-visible', String(!e.isIntersecting && e.boundingClientRect.top < 0));
      }).observe(submit);
    }
  });

  // Delivery timeline dates
  document.querySelectorAll('[data-delivery]').forEach(function (el) {
    var fmt = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });
    function add(n) { var d = new Date(); d.setDate(d.getDate() + n); return d; }
    function range(a, b) {
      var da = add(a), db = add(b);
      if (da.getMonth() === db.getMonth()) return da.getDate() + ' – ' + fmt.format(db);
      return fmt.format(da) + ' – ' + fmt.format(db);
    }
    var n = function (k) { return parseInt(el.getAttribute(k), 10) || 0; };
    var steps = el.querySelectorAll('[data-delivery-step]');
    if (steps[0]) steps[0].textContent = fmt.format(new Date());
    if (steps[1]) steps[1].textContent = range(n('data-ship-min'), n('data-ship-max'));
    if (steps[2]) steps[2].textContent = range(n('data-deliver-min'), n('data-deliver-max'));
  });
})();

/* Chargement sur les boutons : formulaires envoyés et liens vers une autre page */
(function () {
  function load(el) {
    if (!el || !el.classList.contains('button')) return;
    el.classList.add('is-loading');
    el.setAttribute('aria-busy', 'true');
  }
  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;
    load(e.submitter || e.target.querySelector('button[type="submit"].button, button:not([type]).button'));
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.button[href]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
    if (a.hasAttribute('data-sticky-add')) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    try {
      var u = new URL(href, window.location.href);
      if (u.pathname === window.location.pathname && u.search === window.location.search && u.hash) return;
    } catch (err) { return; }
    load(a);
  });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.button.is-loading').forEach(function (el) {
      el.classList.remove('is-loading');
      el.removeAttribute('aria-busy');
    });
  });
})();
